import React, { VFC } from 'react';
import ArrowRightIcon from './icons/ArrowRightIcon';
import ArrowLeftIcon from './icons/ArrowLeftIcon';
import SearchIcon from './icons/SearchIcon';
import PackageIcon from './icons/PackageIcon';
import SendPackageIcon from './icons/SendPackageIcon';
import PlusIcon from './icons/PlusIcon';
import MinusIcon from './icons/MinusIcon';
import LoadingIcon from './icons/LoadingIcon';
import CheckIcon from './icons/CheckIcon';
import CheckWithCircleIcon from './icons/CheckWithCircleIcon';
import CrossIcon from './icons/CrossIcon';
import ChevronDownIcon from './icons/ChevronDownIcon';
import PackagePlusIcon from './icons/PackagePlusIcon';
import TrashIcon from './icons/TrashIcon';
import UploadFileIcon from './icons/UploadFileIcon';
import DownloadIcon from './icons/DownloadIcon';
import LockIcon from './icons/LockIcon';
import FilePlusIcon from './icons/FilePlusIcon';
import ErrorIcon from './icons/Error';
import WarningIcon from './icons/Warning';
import { IconVariants, IconSize } from './icons/types';
import AddPhotoIcon from './icons/AddPhotoIcon';

enum SelectSize {
  xSmall = 10,
  small = 16,
  large = 24,
  xLarge = 44,
}
interface Props extends React.HtmlHTMLAttributes<SVGElement> {
  icon?: IconVariants;
  color?: string;
  iconSize?: IconSize;
}

const SvgIcon: VFC<Props> = ({ icon, color, iconSize = 'small' }) => {
  const iconProps = {
    icon,
    color,
    size: SelectSize[iconSize],
  };
  const SelectIcon = () => {
    switch (icon) {
      case 'arrow-right':
        return <ArrowRightIcon {...iconProps} />;
      case 'arrow-left':
        return <ArrowLeftIcon {...iconProps} />;
      case 'search':
        return <SearchIcon {...iconProps} />;
      case 'package':
        return <PackageIcon {...iconProps} />;
      case 'send-package':
        return <SendPackageIcon {...iconProps} />;
      case 'package-plus':
        return <PackagePlusIcon {...iconProps} />;
      case 'add-photo':
        return <AddPhotoIcon {...iconProps} />;
      case 'plus':
        return <PlusIcon {...iconProps} />;
      case 'minus':
        return <MinusIcon {...iconProps} />;
      case 'loader':
        return <LoadingIcon {...iconProps} />;
      case 'check':
        return <CheckIcon {...iconProps} />;
      case 'check-with-circle':
        return <CheckWithCircleIcon {...iconProps} />;
      case 'cross':
        return <CrossIcon {...iconProps} />;
      case 'chevron-down':
        return <ChevronDownIcon {...iconProps} />;
      case 'trash':
        return <TrashIcon {...iconProps} />;
      case 'upload':
        return <UploadFileIcon {...iconProps} />;
      case 'download':
        return <DownloadIcon {...iconProps} />;
      case 'lock':
        return <LockIcon {...iconProps} />;
      case 'file-plus':
        return <FilePlusIcon {...iconProps} />;
      case 'error':
        return <ErrorIcon />;
      case 'warning':
        return <WarningIcon />;

      default:
        return <p>Icon missing</p>;
    }
  };
  return SelectIcon();
};
export default SvgIcon;
